// 百源拦截器
import type { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import type { HttpResponse } from '../types';
import type { ChatBIHttpResponse } from '../../modules/chat-bi/types';

const isChatBIUrl = (url: string | undefined) => {
  return url?.indexOf('cdbi.') !== -1;
};

export default {
  // 请求拦截器
  request: [
    (config: InternalAxiosRequestConfig) => {
      return config;
    },
    (error: any) => {
      // do something
      return Promise.reject(error);
    },
  ],
  // 响应拦截器
  response: [
    (response: AxiosResponse<HttpResponse>) => {
      if (isChatBIUrl(response.config.url)) {
        // 响应拦截，转换百源响应格式
        const data = response.data as unknown as ChatBIHttpResponse;
        response.data = {
          success: data.ok,
          obj: data.data,
          errorMessage: data.errMsg,
          errorCode: data.errCode,
        };
      }
      return response;
    },
  ],
};
